import type { ReactNode, FC } from 'react';

import styles from './HomeInnerLayout2.module.scss';

interface HomeInnerLayout1Props {
  children: ReactNode;
}

const HomeInnerLayout2: FC<HomeInnerLayout1Props> = ({ children }) => {
  return <div className={styles.container}>{children}</div>;
};

export default HomeInnerLayout2;
